type PanelMessageProps = {
  title: string;
  message: string;
  variant?: "soft" | "primary";
};

export function PanelMessage({ title, message, variant = "soft" }: PanelMessageProps) {
  const panelClassName = variant === "primary" ? "panel panel-primary" : "panel panel-soft";

  return (
    <section className={panelClassName}>
      <h2>{title}</h2>
      <p>{message}</p>
    </section>
  );
}
